import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import IconSvg from 'Components/IconSvg';
import Portal from 'Components/Portal';

const DeleteLibraryItem = ({ onClose, onDelete, onOpen, remove }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [coords, setCoords] = useState({});
  const buttonRef = useRef(null);
  const libraryListEl = document.getElementsByClassName(
    'library-list__virtuoso'
  )[0];

  const handleClick = (event) => {
    event.preventDefault();
    isOpen ? handleClose() : handleOpen();
  };

  const handleOpen = () => {
    const buttonRect = buttonRef.current.getBoundingClientRect();
    setCoords({
      right: window.innerWidth - buttonRect.right,
      top: buttonRect.top + buttonRect.height / 2,
    });
    setIsOpen(true);
    onOpen();
    libraryListEl.addEventListener('scroll', handleClose);
  };

  const handleClose = () => {
    setIsOpen(false);
    onClose();
    libraryListEl.removeEventListener('scroll', handleClose);
  };

  return (
    <div
      className="delete-library-item"
      onBlur={handleClose}
      onClick={handleClick}
    >
      <button
        className={`delete-library-item-head ${isOpen ? 'isOpen' : ''}`}
        ref={buttonRef}
      >
        <IconSvg type="viewMore" />
      </button>
      {isOpen && (
        <Portal>
          <div
            className="delete-library-item-body"
            onMouseDown={onDelete}
            style={{ ...coords }}
          >
            <IconSvg type="delete" />
            <span className="delete-library-item-text">{remove}</span>
          </div>
        </Portal>
      )}
    </div>
  );
};

DeleteLibraryItem.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  remove: PropTypes.string.isRequired,
};

DeleteLibraryItem.defaultProps = {};

export default DeleteLibraryItem;
